import NcmModel from "../../models/produto/ncmModel";
import nfetch from "../../utils/events/nfetch";
import { IService } from "../base/iService";

export default class NcmService extends IService<NcmModel> {
    constructor() {
        super("Ncm");
    }

    public getFromSearchComboById(id: number): Promise<Response> {
        return nfetch(`/${this.controllerName}/GetFromSearchComboById?id=${id}`, {
            credentials: "same-origin",
        });
    }

    public getFromSearchComboByText(filterKey = ""): Promise<Response> {
        return nfetch(`/${this.controllerName}/GetFromSearchComboByText?filterKey=${filterKey}`, {
            credentials: "same-origin",
        });
    }
}
